<template>

  <div
    class="meet-main adapted-video-meet-width"
    :class="fullscreen ? 'fullscreen' : null">

    <div class="alert alert-warning m-0" v-if="transcript === 'no-credits'">
      Você está sem créditos de transcrição no momento, por isso esta reunião não poderá ser transcrita e analisada automaticamente.
    </div>

    <div class="meet-main-iframe">
      <VideoEmbed
        :roomId="token"
        :userName="me.name"
        :showLeaveButton="false" />
    </div>
    <div class="meet-main-actions bg-dark">
      <button
       class="btn btn-dark"
       :class="{ 'btn-outline-light': fullscreen }"
       @click="fullscreen=true">
       <i class="fa-solid fa-expand"></i> Expandir
      </button>
      <button
       class="btn btn-dark"
       :class="{ 'btn-outline-light': !fullscreen }"
       @click="fullscreen=false">
       <i class="fa-solid fa-table-columns"></i> Dividir
      </button>
      <button
       class="btn btn-danger"
       @click="close()">
       <i class="fa-solid fa-phone"></i>
      </button>
    </div>
  </div>

</template>

<script>
import VideoEmbed from './VideoEmbed.vue'
export default {
  name: 'MeetMain',
  components: {
    VideoEmbed
  },
  props: {
    token: {
      type: String,
      required: true
    },
    transcript: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      fullscreen: false
    }
  },
  computed: {
    me () {
      return this.$store.getters.getMe
    }
  },
  mounted () {
  },
  methods: {
    close () {
      this.$store.dispatch('resetMeetcontext')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.meet-main {
  position: absolute;
  z-index: 99999;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
}
  .meet-main > .meet-main-iframe {
    flex: 1;
  }
  .meet-main > .meet-main-actions {
    padding: 10px;
    text-align: center;
  }
.meet-main.fullscreen {
  min-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Meet/MeetMain.vue